import styled from 'styled-components/macro';
import React from 'react';
import { ReactComponent as headerIcon } from '../../../../assets/icons/landingPage/Header.svg';
import { ReactComponent as footerIcon } from '../../../../assets/icons/landingPage/Footer.svg';
import { ReactComponent as typographyIcon } from '../../../../assets/icons/landingPage/Text.svg';

import { FaPalette } from 'react-icons/fa';
import { GoListUnordered } from 'react-icons/go';
import { IoMdImage } from 'react-icons/io';
import { AiOutlineGlobal } from 'react-icons/ai';
import { MdAdsClick } from 'react-icons/md';
import { IUIKitFormData, LPBuilderSidebarCategory } from './types';
import {
  CustomTemplateIcon,
  OemTemplateIcon,
  StockTemplateIcon,
} from './assets';
import { defaultFontFamilyOptions } from 'app/pages/design/landingPageBuilder/components';

export enum LP_DESIGN_CATEGORIES {
  OEM = 'Oem Template',
  STOCK = 'Stock Template',
  CUSTOM = 'Custom Template',
}

export const LpDesignCategories = [
  {
    value: LP_DESIGN_CATEGORIES.OEM,
    label: 'OEM Template',
  },
  {
    value: LP_DESIGN_CATEGORIES.STOCK,
    label: 'Stock Template',
  },
  {
    value: LP_DESIGN_CATEGORIES.CUSTOM,
    label: 'Custom Template',
  },
];
export enum LpBuilderSidebarItems {
  UI_KIT = 'UI Kit',
  IMAGE = 'Image',
  CTA = 'CTAs',
  BODY = 'Body',
  HEADER = 'Header',
  FOOTER = 'Footer',
  SOCIAL_MEDIA = 'Social Media',
}

export enum LpBuilderSidebarCategories {
  DESIGN_SYSTEM = 'Design System',
  STRUCTURE = 'Structure',
  CONTENT_AND_ENGAGEMENT = 'Content & Engagement',
}
export enum FONT_CASE_KEYWORD {
  CAPITALIZED = 'capitalized',
  LOWERCASE = 'lowercase',
  UPPERCASE = 'uppercase',
}

export const FontCases = [
  {
    label: 'Capitalized',
    value: FONT_CASE_KEYWORD.CAPITALIZED,
  },
  {
    label: 'Lowercase',
    value: FONT_CASE_KEYWORD.LOWERCASE,
  },
  {
    label: 'Uppercase',
    value: FONT_CASE_KEYWORD.UPPERCASE,
  },
];

export enum FONT_WEIGHT_KEYWORD {
  THIN = '100',
  LIGHT = '300',
  REGULAR = '400',
  MEDIUM = '500',
  SEMIBOLD = '600',
  BOLD = '700',
  EXTRABOLD = '800',
}

export const FontWeights = [
  {
    label: 'Thin',
    value: FONT_WEIGHT_KEYWORD.THIN,
  },
  {
    label: 'Light',
    value: FONT_WEIGHT_KEYWORD.LIGHT,
  },
  {
    label: 'Regular',
    value: FONT_WEIGHT_KEYWORD.REGULAR,
  },
  {
    label: 'Medium',
    value: FONT_WEIGHT_KEYWORD.MEDIUM,
  },
  {
    label: 'Semibold',
    value: FONT_WEIGHT_KEYWORD.SEMIBOLD,
  },
  {
    label: 'Bold',
    value: FONT_WEIGHT_KEYWORD.BOLD,
  },
  {
    label: 'Extra-Bold',
    value: FONT_WEIGHT_KEYWORD.EXTRABOLD,
  },
];

export enum LP_DESIGN_LOGO {
  // COVIDEO
  WHITE = 'white',
  BLACK = 'black',
  COLOR = 'color',
  COLOR_WHITE_TEXT = 'color_white_text',
  // CDK
  CDK_WHITE = 'cdk_white',
  CDK_BLACK = 'cdk_black',
}

export enum GRADIENT_TYPES {
  DARK = 'dark',
  LIGHT = 'light',
}

export const GradientTypes = [
  {
    value: GRADIENT_TYPES.DARK,
    label: 'Dark Overlay',
  },
  {
    value: GRADIENT_TYPES.LIGHT,
    label: 'Light Overlay',
  },
];

export enum TEXT_ALIGNMENT {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export enum TEXT_ORIENTATION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export enum LP_DESIGN_SOCIAL_MEDIA {
  WHITE_SQUARE = 'white_square',
  BLACK_SQUARE = 'black_square',
  WHITE_CIRCLE = 'white_circle',
  BLACK_CIRCLE = 'black_circle',
  COLORS_SQUARE = 'color_square',
  COLORS_CIRCLE = 'color_circle',
  WHITE = 'white_none',
  BLACK = 'black_none',
}

export const HeaderIcon = styled(headerIcon)`
  width: ${props => props.width || '20px'};
  height: ${props => props.height || '20px'};
  path {
    fill: ${props => props.color || 'currentColor'};
    opacity: ${props => props.opacity || 'inherit'};
  }
`;
export const FooterIcon = styled(footerIcon)`
  width: ${props => props.width || '20px'};
  height: ${props => props.height || '20px'};
  path {
    fill: ${props => props.color || 'currentColor'};
    opacity: ${props => props.opacity || 'inherit'};
  }
`;
export const TypographyIcon = styled(typographyIcon)`
  width: ${props => props.width || '20px'};
  height: ${props => props.height || '20px'};
  path {
    fill: ${props => props.color || 'currentColor'};
    opacity: ${props => props.opacity || 'inherit'};
  }
`;

export const useGetSidebarItems = (): LPBuilderSidebarCategory[] => {
  return [
    {
      title: LpBuilderSidebarCategories.DESIGN_SYSTEM,
      items: [
        { name: LpBuilderSidebarItems.UI_KIT, icon: FaPalette },
        { name: LpBuilderSidebarItems.IMAGE, icon: IoMdImage },
      ],
    },
    {
      title: LpBuilderSidebarCategories.STRUCTURE,
      items: [
        { name: LpBuilderSidebarItems.HEADER, icon: HeaderIcon },
        { name: LpBuilderSidebarItems.BODY, icon: GoListUnordered },
        { name: LpBuilderSidebarItems.FOOTER, icon: FooterIcon },
      ],
    },
    {
      title: LpBuilderSidebarCategories.CONTENT_AND_ENGAGEMENT,
      items: [
        { name: LpBuilderSidebarItems.CTA, icon: MdAdsClick },
        { name: LpBuilderSidebarItems.SOCIAL_MEDIA, icon: AiOutlineGlobal },
      ],
    },
  ];
};

export const FontSizes = [
  {
    label: '10px',
    value: 10,
  },
  {
    label: '12px',
    value: 12,
  },
  {
    label: '14px',
    value: 14,
  },
  {
    label: '16px',
    value: 16,
  },
  {
    label: '20px',
    value: 20,
  },
  {
    label: '24px',
    value: 24,
  },
  {
    label: '27px',
    value: 27,
  },
  {
    label: '32px',
    value: 32,
  },
  {
    label: '36px',
    value: 36,
  },
  {
    label: '40px',
    value: 40,
  },
  {
    label: '48px',
    value: 48,
  },
  {
    label: '64px',
    value: 64,
  },
];

export const LandingPageBuilderLogos = [
  {
    value: LP_DESIGN_LOGO.BLACK,
    label: 'Black',
  },
  {
    value: LP_DESIGN_LOGO.WHITE,
    label: 'White',
  },
  {
    value: LP_DESIGN_LOGO.COLOR,
    label: 'Color',
  },
  {
    value: LP_DESIGN_LOGO.COLOR_WHITE_TEXT,
    label: 'Color with White Text',
  },
  {
    value: LP_DESIGN_LOGO.CDK_WHITE,
    label: 'CDK White',
  },
  {
    value: LP_DESIGN_LOGO.CDK_BLACK,
    label: 'CDK Black',
  },
];

// do not use rgba for these values
export const LP_DESIGN_COMMON_COLORS = {
  BLACK: '#000000FF',
  WHITE: '#FFFFFFFF',
  GRAY20: '#EEEFF2',
  GRAY40: '#D0D3D9FF',
};

export const INITIAL_UI_KIT_VALUES: IUIKitFormData = {
  title: '',
  thumbnail: { file: null, url: '' },
  bodyBackgroundColor: LP_DESIGN_COMMON_COLORS.GRAY20,
  buttonColor: LP_DESIGN_COMMON_COLORS.BLACK,
  footerBackgroundColor: LP_DESIGN_COMMON_COLORS.GRAY40,
  headerBackgroundColor: LP_DESIGN_COMMON_COLORS.GRAY40,
  textColor: LP_DESIGN_COMMON_COLORS.BLACK,
  fontFamily: defaultFontFamilyOptions[0].value,
  bodyFontSize: FontSizes[1].value,
  titleFontSize: FontSizes[1].value,
};

export const TEMPLATE_ICON_MAP: { [key in LP_DESIGN_CATEGORIES]: JSX.Element } =
  {
    [LP_DESIGN_CATEGORIES.OEM]: <OemTemplateIcon />,
    [LP_DESIGN_CATEGORIES.STOCK]: <StockTemplateIcon />,
    [LP_DESIGN_CATEGORIES.CUSTOM]: <CustomTemplateIcon />,
  };

export const ACTIVITY_VALUES = {
  all: 'all',
  active: 'active',
  inactive: 'inactive',
} as const;

export type ActivityValue =
  (typeof ACTIVITY_VALUES)[keyof typeof ACTIVITY_VALUES];

export const getActiveStatus = (value: ActivityValue): boolean | null => {
  if (value === ACTIVITY_VALUES.all) return null;
  if (value === ACTIVITY_VALUES.active) return true;
  if (value === ACTIVITY_VALUES.inactive) return false;
  return null;
};

export const ACTIVITY_OPTIONS = [
  { value: ACTIVITY_VALUES.all, text: 'All' },
  { value: ACTIVITY_VALUES.active, text: 'Active' },
  { value: ACTIVITY_VALUES.inactive, text: 'Inactive' },
];

export const DELETE_AND_REPLACE_TEXT = 'Delete and Replace Template';
export const DELETE_TEMPLATE_TEXT = 'Delete Template';

export const ACTIVE_TEMPLATE_INFO = `You are about to delete a template that is still being used by users. You can select a new template. If the template is not selected the users will have the White page set as their new landing page.`;
export const INACTIVE_TEMPLATE_INFO = `This template is not being used by any customer or reseller. Would you like to proceed?`;

export const CREATE_NEW_GROUP_ID = 0;

export const LP_BUILDER_MODAL_STEPS = {
  design: 'design',
  manageAccess: 'manageAccess',
  changesSummary: 'changesSummary',
} as const;

export const LP_BUILDER_FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  BULK_EDIT: 'bulk-edit',
} as const;

export type LpBuilderFormMode =
  (typeof LP_BUILDER_FORM_MODE)[keyof typeof LP_BUILDER_FORM_MODE];

export const DEFAULT_DESIGNS_SIZE = 9;
export const AUTOCOMPLETE_DATA_LIMIT = 9;
export const DEFAULT_DESIGNS_OPTIONS = [9, 18, 27, 36, 45];

export const DEFAULT_GROUPS_OPTIONS = [10, 25, 50, 100];
